import * as types from '@/store/types';
import Cookies from 'js-cookie';
import i18n from '@/plugins/i18n';

export default {
  [types.SET_LOCALE](state, locale) {
    Cookies.set('locale', locale);
    state.locale = locale;
    i18n.locale = locale;
  }
};
